export const TRAVEL_PARTY_CONSTANTS = {
    adultsLabelAria: 'stateroom.adultsLabelAria',
    adultslowerLimit: 1,
    adultsUpperLimit: 5,
    callUrl: '/help/phone',
    checkboxTimeout: 500,
    childrenLabelAria: 'stateroom.childrenLabelAria',
    childsUpperLimit: 4,
    cookie: {
        name: 'party_mix'
    },
    infantAge: 6,
    infantLabel: 'Infant',
    maxAmountOfStateroom: 4,
    maxInfantAge: 2,
    maxInfantsPerAdult: 2,
    maxNonAdultAge: 17,
    maxOfGuestsPerStateroom: 5,
    monthLabel: 'MONTH',
    yearLabel: 'YEAR',
    travelPartyError: 'TP_Error',
    analytics: {
        indicators: {
            adults: 'A',
            children: 'C',
            infants: 'I',
            staterooms: 'S'
        },
        actionTypes: {
            accessible: 'AccessibleAdd',
            removeStateroom: 'StateroomRemove',
            addStateroom: 'StateroomAdd',
            child: 'Child',
            adult: 'Adult'
        }
    }
};
